import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-velux',
  templateUrl: './velux.component.html',
  styleUrls: ['./velux.component.scss']
})
export class VeluxComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
